import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=29f50e01&scoped=true"
import script from "./Feedbacks.vue?vue&type=script&lang=js"
export * from "./Feedbacks.vue?vue&type=script&lang=js"
import style0 from "./Feedbacks.vue?vue&type=style&index=0&id=29f50e01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f50e01",
  null
  
)

export default component.exports